import { render, staticRenderFns } from "./MyRecord.vue?vue&type=template&id=ec6a29e2&scoped=true"
import script from "./my-record.ts?vue&type=script&lang=ts&external"
export * from "./my-record.ts?vue&type=script&lang=ts&external"
import style0 from "./my-record.scss?vue&type=style&index=0&id=ec6a29e2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6a29e2",
  null
  
)

export default component.exports